import { cAPI } from '../../../utils/cAPI';
import { addEditData, getData } from '../generic';

export const getShipmentServices = () => dispatch => getData(dispatch, cAPI.APGetShipmentServices, null);
export const getShipmentServiceParams = id => async dispatch => await getData(dispatch, cAPI.APGetShipmentServiceParams, id);
export const sendShipments = formData => dispatch => addEditData(dispatch, cAPI.APSendShipments, formData, null, false, false, true);